import { useLanguage } from '@/context/LanguageContext'
import { TravelPoint } from '@/lib/network-coverage-v2/types'
import { getSystemEnv } from '@/utils/env'
import useIntl from '@/utils/intl'
import { GoogleMap, InfoWindow, Marker, useJsApiLoader } from '@react-google-maps/api'
import { FunctionComponent, useState } from 'react'

const containerStyle = {
  width: '100%',
  height: '100%'
}
export interface LatLong {
  id?: number
  travelPoint?: TravelPoint
  lat: number
  lng: number
}

interface Props {
  zoom: number
  markers: LatLong[]
  center: LatLong
  onClick?: (id: number) => void
  userLocation?: { lat: number, lng: number } | null
}

const GoogleMaps: FunctionComponent<Props> = ({ zoom, markers, center, onClick, userLocation }) => {
  const [selectedMarker, setSelectedMarker] = useState<LatLong | null>(null)
  const { locale } = useLanguage()
  const { translate } = useIntl()
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: getSystemEnv().GOOGLE_MAP_API_KEY
  })

  const handleClick = (marker: LatLong): void => {
    setSelectedMarker(marker)
    if (marker.id !== undefined && onClick !== undefined) {
      onClick(marker.id)
    }
  }

  return isLoaded
    ? (
      <GoogleMap mapContainerStyle={containerStyle} center={center} zoom={zoom}>
        {markers.map((marker: LatLong) => (
          <Marker key={marker.id ?? `${marker.lat}-${marker.lng}`} position={marker} onClick={() => handleClick(marker)} />
        ))}
        {((selectedMarker?.travelPoint) != null) && (
          <InfoWindow
            position={{ lat: selectedMarker.lat, lng: selectedMarker.lng }}
            onCloseClick={() => setSelectedMarker(null)}
          >
            <div className='p-1'>
              <h1 className='xl:text-lg md:text-sm text-xs font-bold text-ellipsis overflow-hidden h-12'>
                {locale === 'mn' ? selectedMarker.travelPoint?.nameMn : selectedMarker.travelPoint?.nameEn}
              </h1>
              <div className='flex justify-between gap-1'>
                <p className='text-textMid text-xs md:text-sm font-medium'>{translate('networktype')}:</p>
                <span className='text-textHigh text-xs md:text-sm font-medium whitespace-pre-line text-end'>
                  <span className='justify-end text-sm font-bold'>
                    {selectedMarker.travelPoint?.twoG && '2G '}
                    {selectedMarker.travelPoint?.threeG && '3G '}
                    {selectedMarker.travelPoint?.fourG && '4G '}
                    {selectedMarker.travelPoint?.fiveG && '5G '}
                  </span>
                </span>
              </div>
            </div>
          </InfoWindow>
        )}
        {(userLocation != null) && (
          <Marker
            position={userLocation}
            zIndex={1000}
            icon={{
              path: window.google.maps.SymbolPath.CIRCLE,
              scale: 7,
              fillColor: '#4436fa',
              fillOpacity: 1,
              strokeColor: 'white',
              strokeWeight: 2
            }}
          />
        )}
      </GoogleMap>
      )
    : <></>
}

export default GoogleMaps
